import { createReducer } from '@reduxjs/toolkit';
import { fullSetCrossTabState, setCrossTabState, } from '@innovyze/stylovyze/lib/actions/crossTabStates.actions';
import { STATUS_ENUM } from '../types';
export var StateKeys;
(function (StateKeys) {
    StateKeys["inEmulation"] = "inEmulation";
})(StateKeys || (StateKeys = {}));
export const initialState = {
    status: STATUS_ENUM.IDLE,
    crossStates: {
        inEmulation: {
            current: false,
            old: false,
            status: STATUS_ENUM.IDLE,
        },
    },
};
const reducer = {
    [setCrossTabState.toString()]: (s, action) => {
        const oldState = s.crossStates[action.payload.key].current;
        return {
            ...s,
            crossStates: {
                ...s.crossStates,
                [action.payload.key]: {
                    current: action.payload.value,
                    old: oldState,
                    status: STATUS_ENUM.SUCCESS,
                },
            },
        };
    },
    [fullSetCrossTabState.toString()]: (s, action) => {
        localStorage.setItem(action.payload.key, JSON.stringify(action.payload.value));
        const oldState = s.crossStates[action.payload.key].current;
        return {
            ...s,
            crossStates: {
                ...s.crossStates,
                [action.payload.key]: {
                    current: action.payload.value,
                    old: oldState,
                    status: STATUS_ENUM.SUCCESS,
                },
            },
        };
    },
};
export default createReducer(initialState, reducer);
